import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Helmet } from "react-helmet";
import { Container } from "semantic-ui-react";
export function WrapComponent({ embedded, children, title, actions, hideTitle, as: ContainerComponent = Container, }) {
    if (embedded)
        return _jsx("div", { children: children });
    return (_jsxs(ContainerComponent, { className: "wide-content pb-16", fluid: true, children: [_jsx(Helmet, { children: _jsx("title", { children: title }) }), actions ? (_jsx(_Fragment, { children: _jsxs("div", { className: "flex flex-col md:flex-row justify-between", children: [_jsx("h1", { className: "flex-1 text-xl", children: title }), actions] }) })) : (!hideTitle && (_jsx("h1", { className: "text-xl", children: title }))), children] }));
}
